var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.announcements.length
    ? _c(
        "div",
        { staticClass: "chi-announcements" },
        [
          _c("h2", { staticClass: "with-cropped-hr centered" }, [
            _vm._v("Announcements")
          ]),
          _vm._l(_vm.announcements, function(announcement) {
            return _c(
              "div",
              { key: announcement.date, staticClass: "chi-announcement" },
              [
                announcement.title || announcement.date
                  ? _c(
                      "h3",
                      {
                        style: announcement.important
                          ? { color: "#ea5e4a !important" }
                          : {}
                      },
                      [
                        _vm._v(" " + _vm._s(announcement.title) + " "),
                        announcement.date
                          ? _c("span", { staticClass: "chi-pub-date" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    new Date(
                                      announcement.date
                                    ).toLocaleDateString()
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                announcement.content
                  ? _c("p", {
                      domProps: { innerHTML: _vm._s(announcement.content) }
                    })
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }